import { useOutletContext } from 'react-router-dom'
import { TImpressos } from 'service/api'

export function useRelatoriosAjustesImpressosOutletContext() {
    return useOutletContext<{
        data: TImpressos[]
    }>()
}
